<template>
    <b-container>
        <b-row>
            <b-col cols="12">
                <b-form-group
                    id="fieldset-driver"
                    label="Officer"
                    label-for="input-officer"
                >
                    <b-form-select
                        id="input-officer"
                        v-model="model.driver_id"
                        value-field="id"
                        text-field="name"
                        :options="driverOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6">
                <b-form-group
                    id="fieldset-created_start"
                    label="Start Date"
                    label-for="input-created_start"
                >
                    <b-form-input
                        type="date"
                        id="input-created_start"
                        v-model="model.created_start"
                    ></b-form-input>
                </b-form-group>
            </b-col>

            <b-col cols="6">
                <b-form-group
                    id="fieldset-created_end"
                    label="End Date"
                    label-for="input-created_end"
                >
                    <b-form-input
                        type="date"
                        id="input-created_end"
                        v-model="model.created_end"
                    ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-type"
                    label="Type"
                    label-for="input-type"
                >
                    <b-form-select
                        id="input-type"
                        value-field="id"
                        text-field="name"
                        v-model="model.order_type_id"
                        :options="orderTypes"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-is_updated"
                    label="Updates"
                    label-for="input-is_updated"
                >
                    <b-form-select
                        id="input-is_updated"
                        v-model="model.is_updated"
                        :options="is_updatedOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col cols="4">
                <b-form-group
                    id="fieldset-completed"
                    label="Completed"
                    label-for="input-completed"
                >
                    <b-form-select
                        id="input-completed"
                        v-model="model.completed"
                        :options="completedOptions"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'reports-queryBuilder',
    mixins: [permissionsMixins],
    data: () => ({}),
    props: ['value', 'orderTypes', 'officers'],
    computed: {
        model: {
            // getter
            get() {
                return this.value
            },
            // setter
            set(val) {
                this.$emit('input', val)
            },
        },
        driverOptions() {
            const _officers = [...this.officers]

            _officers.unshift(
                { id: 0, name: 'Any' },
                { id: -1, name: 'Assigned' },
                { id: -2, name: 'Unassigned' }
            )
            return _officers
        },
        is_updatedOptions() {
            return [
                { value: 'any', text: 'Any' },
                { value: 'changed', text: 'Changed' },
                { value: 'notChanged', text: 'Not Changed' },
            ]
        },

        completedOptions() {
            return [
                { value: 'any', text: 'Any' },
                { value: 'yes', text: 'Yes' },
                { value: 'no', text: 'No' },
            ]
        },
    },
    watch: {},
    mounted() {},
    methods: {},
}
</script>
